import { ButtonPopup } from "../ui";
import { useNavigate } from "react-router-dom";

interface PopupBajaProps {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

const PopupBaja: React.FC<PopupBajaProps> = ({ onConfirm, onCancel }) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    try {
      await onConfirm();
      navigate("/popuBajaDefinitiva");
    } catch (err: any) {
      console.error("Error en baja:", err);
      alert("No se pudo realizar la baja: " + (err.message || err));
    }
  };

  return (
    <div className="fixed inset-0 flex xs:items-start md:items-center top-20 justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-xl p-6 w-80 text-center shadow-lg dark:text-zinc-700">
        
        <h2 className="text-lg font-semibold mb-4">¿Estás seguro?</h2>
        <p className="mb-6">Esta acción pausará tu suscripción.</p>

        <div className="flex justify-center gap-4">
          <ButtonPopup
            onClick={handleClick}
            className="transition-all duration-300 hover:shadow-md border-red-600 hover:shadow-red-600 hover:border-red-600 hover:border-2"
          >
            Pausar
          </ButtonPopup>

          <ButtonPopup
            onClick={onCancel}
            className="transition-all duration-300 hover:shadow-md hover:shadow-blue-600 border-blue-600 hover:border-2 hover:border-blue-600"
          >
            Cancelar
          </ButtonPopup>
        </div>

      </div>
    </div>
  );
};

export default PopupBaja;